import { cn } from '@/lib/utils'
import { useBrand, splitBrandName } from '@/hooks/useBrand'

interface WordmarkProps {
  size?: 'sm' | 'md' | 'lg'
  variant?: 'auto' | 'light'
  iconOnly?: boolean
  stacked?: boolean
  className?: string
}

const logoSizes = {
  sm: 'h-7',
  md: 'h-8',
  lg: 'h-14',
}

const textSizes = {
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-3xl',
}

export default function Wordmark({ size = 'md', variant = 'auto', iconOnly = false, stacked = false, className }: WordmarkProps) {
  const brand = useBrand()
  const [baseName, suffix] = splitBrandName(brand.appName)
  const nameColor = variant === 'light' ? 'text-white' : 'text-foreground dark:text-white'
  const dotColor = variant === 'light' ? 'text-[#7a9df8]' : 'text-[#4d71fd] dark:text-[#7a9df8]'

  return (
    <span
      className={cn(
        stacked
          ? 'inline-flex flex-col items-center gap-2'
          : 'inline-flex items-center gap-2',
        'font-heading select-none',
        className
      )}
    >
      {brand.logoUrl && (
        <img
          src={brand.logoUrl}
          alt={brand.appName}
          className={cn('w-auto', logoSizes[size])}
        />
      )}
      {!iconOnly && (
        <span className={cn('inline-flex items-baseline', textSizes[size])}>
          <span className={cn('font-extrabold', nameColor)}>{baseName}</span>
          {suffix && <span className={cn('font-light', dotColor)}>{suffix}</span>}
        </span>
      )}
    </span>
  )
}
